/**
 * The tokens a theme is allowed to change. Semantic roles only: rewriting a
 * palette entry would leak a partner's brand everywhere the palette is used.
 * Status colors are left out so a partner cannot decide what an error is.
 */
export const THEMEABLE_TOKENS = {
  accent: { cssVar: '--color-accent', kind: 'color' },
  accentStrong: { cssVar: '--color-accent-strong', kind: 'color' },
  accentSubtle: { cssVar: '--color-accent-subtle', kind: 'color' },
  onAccent: { cssVar: '--color-on-accent', kind: 'color' },

  surface: { cssVar: '--color-surface', kind: 'color' },
  surfaceSubtle: { cssVar: '--color-surface-subtle', kind: 'color' },
  surfaceInverse: { cssVar: '--color-surface-inverse', kind: 'color' },

  body: { cssVar: '--color-body', kind: 'color' },
  muted: { cssVar: '--color-muted', kind: 'color' },
  onInverse: { cssVar: '--color-on-inverse', kind: 'color' },

  border: { cssVar: '--color-border', kind: 'color' },
  borderStrong: { cssVar: '--color-border-strong', kind: 'color' },

  radiusSm: { cssVar: '--radius-sm', kind: 'length' },
  radiusMd: { cssVar: '--radius-md', kind: 'length' },
  radiusLg: { cssVar: '--radius-lg', kind: 'length' },
  radiusXl: { cssVar: '--radius-xl', kind: 'length' },

  fontTitle: { cssVar: '--font-title', kind: 'font' },
  fontBody: { cssVar: '--font-body', kind: 'font' },
} as const satisfies Record<string, { cssVar: string; kind: 'color' | 'font' | 'length' }>;

export type ThemeToken = keyof typeof THEMEABLE_TOKENS;

export type Theme = Partial<Record<ThemeToken, string>>;
